module.exports = "./img/f39cf3b23ef38c8220df77ba7d92bd16.jpg";